// extracted by mini-css-extract-plugin
export var back = "PickSlip-module--back--b4177";
export var blue = "#0eb3f2";
export var button = "PickSlip-module--button--d1014";
export var buttons = "PickSlip-module--buttons--63c86";
export var cardWrapper = "PickSlip-module--cardWrapper--d34ae";
export var center = "PickSlip-module--center--b1562";
export var clamp = "PickSlip-module--clamp--154f6";
export var clickable = "PickSlip-module--clickable--d0a2b";
export var close = "PickSlip-module--close--b6bf7";
export var container = "PickSlip-module--container--1a81a";
export var content = "PickSlip-module--content--b3446";
export var emphasis = "PickSlip-module--emphasis--9fb3e";
export var empty = "PickSlip-module--empty--2735e";
export var eventName = "PickSlip-module--eventName--502e4";
export var exoticTitle = "PickSlip-module--exoticTitle--897e0";
export var footer = "PickSlip-module--footer--4c8ef";
export var green = "#57d33b";
export var greenLink = "PickSlip-module--green-link--46c3b";
export var grey = "var(--tone-mid)";
export var header = "PickSlip-module--header--e44e1";
export var hidden = "PickSlip-module--hidden--e2163";
export var icon = "PickSlip-module--icon--79e33";
export var iconButton = "PickSlip-module--iconButton--395d1";
export var info = "PickSlip-module--info--6998f";
export var isReviewing = "PickSlip-module--isReviewing--b0b46";
export var label = "PickSlip-module--label--bd0af";
export var largeFooter = "PickSlip-module--largeFooter--b52dc";
export var marketName = "PickSlip-module--marketName--47fc9";
export var notchGap = "32px";
export var orange = "#f8662b";
export var outcomeIcon = "PickSlip-module--outcomeIcon--aaf19";
export var panel = "PickSlip-module--panel--9a00c";
export var pickCount = "PickSlip-module--pickCount--01004";
export var picksAccepted = "PickSlip-module--picksAccepted--cae5f";
export var red = "#ff2741";
export var right = "PickSlip-module--right--5913d";
export var scrollArea = "PickSlip-module--scrollArea--3e2cf";
export var selectionName = "PickSlip-module--selectionName--c7df9";
export var small = "PickSlip-module--small--4b4bf";
export var smallFooter = "PickSlip-module--smallFooter--649c4";
export var stickyAlerts = "PickSlip-module--stickyAlerts--78535";
export var tab = "PickSlip-module--tab--63a9b";
export var tabList = "PickSlip-module--tabList--43520";
export var tabListContainer = "PickSlip-module--tabListContainer--f1d97";
export var tabs = "PickSlip-module--tabs--0d98f";
export var title = "PickSlip-module--title--e3049";
export var trash = "PickSlip-module--trash--01bf8";
export var value = "PickSlip-module--value--4988e";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";